(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-submenu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ariSubmenuTruncate) return;
    window.__ariSubmenuTruncate = true;

    function collapseColumn(column) {
      column.querySelectorAll('.submenu-item--extra').forEach(function (item) {
        item.hidden = true;
      });

      var toggle = column.querySelector('[data-submenu-toggle]');
      if (!toggle) return;

      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-expanded');

      var label = toggle.querySelector('[data-submenu-label]');
      if (label && toggle.dataset.labelMore) {
        label.textContent = toggle.dataset.labelMore;
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-submenu-toggle]');
      if (!toggle) return;

      event.preventDefault();

      var column = toggle.closest('.submenu-column');
      if (!column) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var nextExpanded = !expanded;

      column.querySelectorAll('.submenu-item--extra').forEach(function (item) {
        item.hidden = !nextExpanded;
      });

      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      toggle.classList.toggle('is-expanded', nextExpanded);

      var label = toggle.querySelector('[data-submenu-label]');
      if (label) {
        label.textContent = nextExpanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      }
    });

    function collapseNavItem(navItem) {
      navItem.querySelectorAll('.submenu-column--with-children').forEach(collapseColumn);
    }

    document.addEventListener('mouseout', function (event) {
      var navItem = event.target.closest && event.target.closest('.nav-item.has-submenu');
      if (!navItem) return;
      var next = event.relatedTarget;
      if (next && navItem.contains(next)) return;
      collapseNavItem(navItem);
    });

    document.addEventListener('focusout', function (event) {
      var navItem = event.target.closest && event.target.closest('.nav-item.has-submenu');
      if (!navItem) return;
      var next = event.relatedTarget;
      if (next && navItem.contains(next)) return;
      collapseNavItem(navItem);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share"] && !Shopify.designMode) return;
  try {
    (function () {
    const shareLinks = document.querySelectorAll('.share-link[data-share-url]');
    shareLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (!navigator.share) return;
        var url = link.getAttribute('data-share-url');
        var title = link.getAttribute('data-share-title') || document.title;
        var text = link.getAttribute('data-share-text') || '';
        navigator.share({ url: url, title: title, text: text }).catch(function () {
          window.location.href = link.getAttribute('href');
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
